import React from 'react';
import MetaHistory from '../../components/metaai/MetaHistory';

const MetaAIHistory = () => {
  return (
    <div>
      <MetaHistory />
    </div>
  )
}

export default MetaAIHistory